import {useMutation, useQueryClient} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {updateTaxProgress} from "../../../../api/order/TaxInvoiceApi";
import {useModal} from "../../../../hooks";
import {TaxInvoiceListElementType} from "../interface";


export const useUpdateTaxProgress = ({closeCallback}: { closeCallback: () => any }) => {
    const {handleModal} = useModal();
    const qc = useQueryClient()

    const {mutate} = useMutation({
        mutationFn: (data: TaxInvoiceListElementType[]) => updateTaxProgress(data),
        onSuccess: () => {
            handleModal({
                isOpen: true,
                contents: "수정되었습니다",
                type: "alert",
                closeAction: () => closeCallback()
            });

            qc.invalidateQueries({queryKey: ["readTaxList"]})
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate};
};
